module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst dataJSON = model.dataJSON || {}\nconst code = dataJSON.code || ''\nconst passwordSetAt = dataJSON.passwordSetAt || ''\nconst passwordSentViaMailAt = dataJSON.passwordSentViaMailAt || ''\nconst passwordSentViaSMSAt = dataJSON.passwordSentViaSMSAt || ''\nlet passwordSentAt = passwordSentViaMailAt || passwordSentViaSMSAt\nif(passwordSentViaMailAt > passwordSentViaSMSAt){\npasswordSentAt = passwordSentViaMailAt\n} else if(passwordSentViaMailAt < passwordSentViaSMSAt){\npasswordSentAt = passwordSentViaSMSAt\n}\nconst additionalClasses = []\nconst fieldClasses = []\nconst status = {\nsymbol: '',\nmessage: ''\n}\nif(code){\nif(passwordSetAt){\nstatus.symbol = 'fi fi-check-double'\n} else if(passwordSentViaMailAt || passwordSentViaSMSAt) {\nstatus.symbol = 'fi fi-check'\nstatus.message = storage.__('form.fields.userAndPassword.missingConfirmation')\n} else {\nstatus.symbol = 'fi fi-exclamation-triangle'\nstatus.message = storage.__('form.fields.userAndPassword.missingPassword')\n}\n}\n%><div class=\"<%- additionalClasses.join(' ') %>\">\n<div class=\"data\">\n<div class=\"confirmation\">\n<%\nif(passwordSentAt){\nconst m = utils.moment(passwordSentAt)\nlet key = ''\nif(passwordSentViaMailAt && passwordSentViaSMSAt){\nkey = 'confirmedViaMailAndSmsAt'\n} else if(passwordSentViaMailAt){\nkey = 'confirmedViaMailAt'\n} else if(passwordSentViaSMSAt){\nkey = 'confirmedViaSmsAt'\n}\nif(key){\n%><%- storage.__(`form.fields.userAndPassword.${key}`, { date: m.format('DD.MM.YYYY'), time: m.format('HH:mm') }) %><%\n}\n}\n%>\n</div>\n<input data-field-type=\"text\" type=\"text\" value=\"<%= code %>\"<%- (model.disabled ? 'disabled=\"disabled\"' : ''); %> placeholder=\"<%= model.placeholder || '' %>\" class=\"<%= fieldClasses.join(' ') %>\"/>\n<%\nif(status.symbol){\n%><i class=\"<%- status.symbol %>\" title=\"<%= status.message %>\"></i><%\n}\n%>\n</div>\n<div class=\"controls\">\n<%\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'resetPassword', context: 'user', mode: '', symbolOnly: true } }); %><%\n%>\n</div>\n</div>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\fields\\userAndPassword.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const dataJSON = model.dataJSON || {}
const code = dataJSON.code || ''
const passwordSetAt = dataJSON.passwordSetAt || ''
const passwordSentViaMailAt = dataJSON.passwordSentViaMailAt || ''
const passwordSentViaSMSAt = dataJSON.passwordSentViaSMSAt || ''
let passwordSentAt = passwordSentViaMailAt || passwordSentViaSMSAt
if(passwordSentViaMailAt > passwordSentViaSMSAt){
passwordSentAt = passwordSentViaMailAt
} else if(passwordSentViaMailAt < passwordSentViaSMSAt){
passwordSentAt = passwordSentViaSMSAt
}
const additionalClasses = []
const fieldClasses = []
const status = {
symbol: '',
message: ''
}
if(code){
if(passwordSetAt){
status.symbol = 'fi fi-check-double'
} else if(passwordSentViaMailAt || passwordSentViaSMSAt) {
status.symbol = 'fi fi-check'
status.message = storage.__('form.fields.userAndPassword.missingConfirmation')
} else {
status.symbol = 'fi fi-exclamation-triangle'
status.message = storage.__('form.fields.userAndPassword.missingPassword')
}
}

    ; __line = 30
    ; __append("<div class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\">\n<div class=\"data\">\n<div class=\"confirmation\">\n")
    ; __line = 33
    ; 
if(passwordSentAt){
const m = utils.moment(passwordSentAt)
let key = ''
if(passwordSentViaMailAt && passwordSentViaSMSAt){
key = 'confirmedViaMailAndSmsAt'
} else if(passwordSentViaMailAt){
key = 'confirmedViaMailAt'
} else if(passwordSentViaSMSAt){
key = 'confirmedViaSmsAt'
}
if(key){

    ; __line = 45
    ; __append( storage.__(`form.fields.userAndPassword.${key}`, { date: m.format('DD.MM.YYYY'), time: m.format('HH:mm') }) )
    ; 
}
}

    ; __line = 48
    ; __append("\n</div>\n<input data-field-type=\"text\" type=\"text\" value=\"")
    ; __line = 50
    ; __append(escapeFn( code ))
    ; __append("\"")
    ; __append( (model.disabled ? 'disabled="disabled"' : '') )
    ; __append(" placeholder=\"")
    ; __append(escapeFn( model.placeholder || '' ))
    ; __append("\" class=\"")
    ; __append(escapeFn( fieldClasses.join(' ') ))
    ; __append("\"/>\n")
    ; __line = 51
    ; 
if(status.symbol){

    ; __line = 53
    ; __append("<i class=\"")
    ; __append( status.symbol )
    ; __append("\" title=\"")
    ; __append(escapeFn( status.message ))
    ; __append("\"></i>")
    ; 
}

    ; __line = 55
    ; __append("\n</div>\n<div class=\"controls\">\n")
    ; __line = 58
    ; 

    ; __line = 59
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'resetPassword', context: 'user', mode: '', symbolOnly: true } }) )
    ; 

    ; __line = 60
    ; __append("\n</div>\n</div>")
    ; __line = 62
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\fields\userAndPassword.ejs

}